
export const OVERLAY_VALUES = { 
  0: '0', 1: '1', 2: '2', 3: '3', 5: '5', 8: '8', 13: '13', 21: '21', 34: '34', 
  question: '?', infinity: '∞', break: '☕' 
};



// WEBPACK FOOTER //
// ./src/constants.js